<script lang="ts">
    import { calcComissionPayable } from '../../../modules/use-cases/calc-comission'
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Invoice, ServicesOnInvoices } from '../../../modules/posApi/invoices/invoice'
    import LoadSpinner from '../../_common/load-spinner.svelte'

    interface ServiceRow {
        name: string
        gross: number
        discount: number
        fees: number
        commission: number
        net: number
    }

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let grid: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: Invoice[] = await window.api.pos.invoices.getAll({ from, to, service: true })
        let items: ServicesOnInvoices[] = data.flatMap((invoice) => invoice.services || [])
        items = await window.api.utils.utils.assignServicesFromObject(items)
        console.log('relat.items', items)
        loadGrid(items)
        show = false
    }

    function loadGrid(items: ServicesOnInvoices[]) {
        const grouped = new Map<string, ServiceRow>()
        for (const el of items) {
            const key = el.serviceId || '-'
            let acc = grouped.get(key)
            if (!acc) {
                acc = { name: el.service?.name || '[sem serviço]', gross: 0, discount: 0, fees: 0, commission: 0, net: 0 }
                grouped.set(key, acc)
            }
            const gross = (el.valueTable || el.value || 0) * (el.quantity || 0)
            const netOfDiscount = (el.value || 0) * (el.quantity || 0)
            const discount = gross - netOfDiscount
            const fees = el.fee || 0 // já é o total do item, não multiplica por quantity
            const commission = calcComissionPayable(el)
            const net = netOfDiscount - fees - commission

            acc.gross += gross
            acc.discount += discount
            acc.fees += fees
            acc.commission += commission
            acc.net += net
        }

        grid = new GridClass()
        grid.title = 'Vendas por serviço'
        grid.cols.push(new GridCol({ content: 'Serviço' }))
        grid.cols.push(new GridCol({ content: 'Bruto', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Desc/Acresc.', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Vlr Venda', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Taxas', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Comissão', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Líquido', type: GridColTypeEnum.float_2, showTotal: true }))

        const rows = [...grouped.values()].filter((row) => row.gross !== 0).sort((a, b) => a.name.localeCompare(b.name))
        for (const row of rows) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: row.name })
            line.slots.push({ content: row.gross })
            line.slots.push({ content: -row.discount })
            line.slots.push({ content: row.gross - row.discount })
            line.slots.push({ content: -row.fees })
            line.slots.push({ content: -row.commission })
            line.slots.push({ content: row.net })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        grid = grid
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }
</script>

<div class="relat-body">
    <div class="acts h-print">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
